import script from "./DoubleWriteContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./DoubleWriteContent.vue?vue&type=script&setup=true&lang=ts"

import "./DoubleWriteContent.vue?vue&type=style&index=0&id=444d6144&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-444d6144"]])

export default __exports__